/**
 * Return a new style object containing only the properties defined under the provided system keys
 *
 * @example To provide functionality for `MarginProps` and `TypographyProps` you could retrieve
 * the props using the governing system keys of `space` and `typography`:
 * ```tsx
 * const MyComponent = (props) => {
 * // etc.
 * return (
 *   <div sx={{
 *     // styles I want the system props to override
 *     ...systemSxFromProps(props, [...space, ...typography]) // unpack the returned ThemeUIStyleObject
 *     // styles I want to override the system props
 *   }} />
 * );
 * ```
 */
export var systemSxFromProps = function (props, // eslint-disable-line
systemKeys) {
    var result = {};
    for (var _i = 0, systemKeys_1 = systemKeys; _i < systemKeys_1.length; _i++) {
        var property = systemKeys_1[_i];
        if (props[property] !== undefined) {
            // `any` is required here to satisfy typescript, otherwise we get:
            // Expression produces a union type that is too complex to represent.ts(2590)
            result[property] = props[property];
        }
    }
    return result;
};
